import { isElementNode } from 'anodum';
import { EDITABLE_ELEMENTS } from '../constants/editable-elements';

const findClosestEditableElement = (el, { isNodeMounted = true } = {}) => {
  if (!el) return null;

  if (isElementNode(el)) {
    const closestEditableElement = el.closest(EDITABLE_ELEMENTS);

    if (isNodeMounted) {
      return closestEditableElement && closestEditableElement.closest('[contenteditable]')
        ? closestEditableElement
        : null;
    }

    return closestEditableElement;
  }

  return findClosestEditableElement(el.parentNode, { isNodeMounted });
};

export default findClosestEditableElement;
